(function(){
'use strict';

angular.module('classy').component('browseTeamsModal', {
  template: '\n      <modal-frame theme="\'dark\'">\n\n        <modal-title>{{:: $ctrl.title }}</modal-title>\n\n        <div class="browse-teams-modal__search">\n          <i class="fa fa-search browse-teams-modal__search-icon"></i>\n          <input class="browse-teams-modal__search-input"\n          ng-model="$ctrl.query"\n          ng-model-options="{ debounce: 500 }"\n          placeholder="Search for a team" />\n        </div>\n\n        <ul class="browse-teams-modal__list"\n        ng-show="!$ctrl.loading && $ctrl.teams.length">\n          <li class="browse-teams-modal__team"\n          ng-repeat="team in $ctrl.teams"\n          ng-click="$ctrl.onSelect({ $team:team })">\n            <img class="browse-teams-modal__team-logo"\n            ng-src="{{ $ctrl.getTeamPhoto(team) }}" />\n            <div class="browse-teams-modal__team-info">\n              <h1 class="browse-teams-modal__team-info-name">{{:: team.name }}</h1>\n              <span class="browse-teams-modal__team-info-details">\n                {{:: $ctrl.memberText(team) }} &bull;\n                {{:: team.goal * (team.percent_to_goal/100) | currency:\'$\':0 }} Raised\n              </span>\n            </div>\n            <i class="browse-teams-modal__team-select ci ci-right-arrow"></i>\n          </li>\n        </ul>\n\n\n        <div class="browse-teams-modal__none"\n        ng-show="!$ctrl.loading && !$ctrl.teams.length">\n          <p class="create-flow_teams-none-message">\n          No teams found.<br/>\n          <span ng-if="$ctrl.campaign.allow_team_fundraising">Want to <a class="create-flow_teams-none-link" href data-ng-click="$ctrl.goToCreate()">create a new one?</a></span>\n          </p>\n        </div>\n\n        <div class="browse-teams-modal__loading"\n        ng-show="$ctrl.loading">\n          <span class="browse-teams-modal__loading-spinner"\n          ng-style="{ color: $ctrl.primaryColor }"></span>\n        </div>\n\n        <div class="browse-teams-modal__pager"\n        sc-paging="$ctrl.getTeamsEndpoint"\n        ng-model="$ctrl.teams"\n        loading="$ctrl.loading"\n        sort="{ name: \'asc\' }"\n        per-page="$ctrl.perPage"\n        filter="$ctrl.filter">\n        </div>\n\n      </modal-frame>\n    ',
  bindings: {
    campaignId: '<',
    primaryColor: '<',
    title: '<',
    onSelect: '&',
    goToCreate: '&'
  },
  controller: ["scFundraisingTeamsService", "scCampaignsService", function BrowseTeamsModalCtrl(scFundraisingTeamsService, scCampaignsService) {
    this.$onInit = function () {
      this.getTeamsEndpoint = '/campaign/' + this.campaignId + '/joinable-teams';
      this.teams = [];
      this.loading = true;
      this.perPage = 5;
      this.filter = null;
    };

    this.campaign = scCampaignsService.active.current;

    this.getTeamPhoto = scFundraisingTeamsService.getTeamPhoto;

    this.memberText = function (team) {
      return team.total_fundraisers === 1 ? '1 Member' : team.total_fundraisers + ' Members';
    };

    this.$doCheck = function () {
      if (this.query !== this.cachedQuery) {
        this.cachedQuery = this.query;
        if (this.query) {
          this.filter = {
            name: [{
              operand: '*=',
              value: this.query
            }]
          };
        } else {
          this.filter = null;
        }
      }
    };
  }]
});
})();